var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShortGeneration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7.5C2 7.22386 2.22386 7 2.5 7H14.5C14.7761 7 15 7.22386 15 7.5C15 7.77614 14.7761 8 14.5 8H2.5C2.22386 8 2 7.77614 2 7.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 10.8334C2 10.5572 2.22386 10.3334 2.5 10.3334H8.81333C9.08948 10.3334 9.31333 10.5572 9.31333 10.8334C9.31333 11.1095 9.08948 11.3334 8.81333 11.3334H2.5C2.22386 11.3334 2 11.1095 2 10.8334Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortGeneration);
export default __webpack_public_path__ + "static/media/shortGeneration.76d35fa2.svg";
export { ForwardRef as ReactComponent };